import React from "react";
import tick from "../../assets/green_tick.png";
import { TCText } from "../TCText/TCText";
import { BorderButton } from "../borderButton/BorderButton";
import { useSelectCircleStore } from "../../stores/StoreContext";

type props = {};

export const SelectCircleCollapsedHeader: React.FC<props> = () => {
  const selectCircleStore = useSelectCircleStore();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: 12,
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <img src={tick} alt="tick" width={12} height={8} />
        </div>
        <TCText
          style={{ fontWeight: 600, fontSize: 14, color: "white" }}
          value="Selected players"
        />
      </div>
      <BorderButton
        btnStyle={{
          borderColor: "white",
        }}
        textStyle={{
          color: "white",
        }}
        onPress={() => {
          selectCircleStore.expandSelectCircle();
        }}
      />
    </div>
  );
};
